import * as React from 'react';
import {Component} from 'react';
import ApprovedInput from './ApprovedInput';

interface EditTitleProps {
    isChanging: boolean;
    children: React.ReactChildren;
}

export default class ToggleEditTitle extends Component<EditTitleProps & any, null> {
    render() {
        const {isChanging, children} = this.props;

        return isChanging ? <ApprovedInput {...this.props} /> : children;
    }
}
